import UnitTransactionsHtml from './unit-transactions.html';

export function UnitTransactions () {
  return {
    controller: 'UnitTransactionsCtrl',
    restrict: 'E',
    templateUrl: UnitTransactionsHtml,
    scope: {
      unit: '='
    }
  }
}